<template>
	<div>
		<div v-if="loading">
			<preloader></preloader>
		</div>
		<button class="btn btn-primary my-3 ml-3" v-on:click="getPolizas">
			<i class="material-icons">refresh</i>
		</button>
		<div class="fixed-action-btn" v-if="roleUser() != 'V'">
		    <a 
		    	href="#" 
		    	class="btn btn-success btn-floating btn-large" 
		    	v-tooltip="'Agregar Póliza'"  
		    	v-on:click.prevent="openModalPoliza">
		        <i class="material-icons">note_add</i>
		    </a>
		</div>
		<div class="table-responsive" v-if="polizas.length>0">
			<table class="table table-bordered table-striped">
	            <thead>
	                <tr>
	                	<th>Póliza Ref.</th>
	                    <th>Cliente</th>
	                    <th>Vendedor</th>
	                    <th>Estatus</th>
	                    <th>Aseguradora</th>
	                    <th>Producto</th>
	                    <th></th>
	                </tr>
	            </thead>
	            <tbody>
	            	<tr v-for="poliza in polizas">
	            		<td>{{poliza.CODIGO_POLIZA_REF}}</td>
	            		<td>{{poliza.cliente.NOMBRE_CLIENTE}}</td>
	            		<td>{{poliza.vendedor.NOMBRE_VENDEDOR}}</td>
	                    <td v-if="poliza.ESTATUS == 'V'">V - Vigente</td>
	                    <td v-else>No Vigente</td>
	                    <td>{{poliza.aseguradora.DESCRIPCION_ASEGURADORA}}</td>
	                    <td>{{poliza.producto.DESCRIPCION_PRODUCTO}}</td>
	                    <td class="text-center">
	                    	<a :href="getUrl(poliza.CODIGO_POLIZA)" class="btn btn-table btn-sm" v-tooltip="'Recibo provisional'" target="_blank">
                                <i class="material-icons">receipt</i>
                            </a>
	                        <button 
	                        	href="#" 
	                        	class="btn btn-table btn-sm" 
	                        	v-tooltip="'Ver Póliza'" 
	                        	v-on:click.prevent="showPoliza(poliza)">
	                            <i class="material-icons">search</i>
	                        </button>
	                        <button 
	                        	href="#" 
	                        	class="btn btn-table btn-sm" 
	                        	v-tooltip="'Editar Póliza'" 
	                        	v-on:click.prevent="editPoliza(poliza)"
	                        	v-if="roleUser() != 'V'">
	                            <i class="material-icons">edit</i>
	                        </button>
	                    </td>
	                </tr>
	            </tbody>
	            <tfoot v-if="false">
	            	<tr>
	            		<th colspan="3" class="text-right">
	            			Total
	            		</th>
	            		<th class="text-right px-1">
	            			
	            		</th>
	            		<td></td>
	            	</tr>
	            </tfoot>
	        </table>
	    </div>
	    <div v-if="polizas.length<=0 && !loading">
	    	<empty icon="note_add" title="Agrega Póliza." description="Para poder visualizar el Póliza debes agregar un nuevo póliza.">
                <a 
                	href="#" 
                	v-on:click.prevent="openModalPoliza" 
                	class="btn btn-success" 
                	v-tooltip="'Agregar Póliza'"
                	v-if="roleUser() != 'V'">
                    <i class="material-icons">add</i> Agregar Póliza
                </a>
            </empty>
	    </div>

    	<div class="modal fade" id="modalPoliza" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
			    <div class="modal-content">
			      	<div class="modal-header">
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='create'">
			        		Registrar Póliza
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='show'">
			        		Ver Póliza {{form.id.value}}
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='edit'">
			        		Editar Póliza
			        	</h5>
			    	</div>
			    	<div class="modal-body p-0">
			    		<ul class="nav nav-tabs" id="myTabPolizasOportunidades" role="tablist">
						 	<li class="nav-item">
						    	<a class="nav-link active" id="detalles-tab" data-toggle="tab" href="#detalles" role="tab" aria-controls="detalles" aria-selected="true">Detalles</a>
						  	</li>

						  	<li class="nav-item">
						    	<a class="nav-link" id="bienes-tab" data-toggle="tab" href="#bienes" role="tab" aria-controls="bienes" aria-selected="true">
						    		Bienes asegurados
						    		<span id="badge-bienes" class="badge badge-light">
			                            0
			                        </span>
						    	</a>
						  	</li>

						  	<li class="nav-item" v-show="modal=='show' || modal=='edit'">
						    	<a class="nav-link" id="endosos-tab" data-toggle="tab" href="#endosos" role="tab" aria-controls="endosos" aria-selected="false">
						    		Endosos
						    		<span id="badge-endosos" class="badge badge-light">
			                            0
			                        </span>
						    	</a>
						  	</li>

						  	<li class="nav-item" v-show="modal=='show' || modal=='edit'">
						    	<a class="nav-link" id="cobros-programados-tab" data-toggle="tab" href="#cobros-programados" role="tab" aria-controls="cobros-programados" aria-selected="false">
						    		Cobros Programados
						    		<span id="badge-cobros-programados" class="badge badge-light">
			                            0
			                        </span>
						    	</a>
						  	</li>

						  	<li class="nav-item" v-show="modal=='show' || modal=='edit'">
						    	<a class="nav-link" id="cobros-realizados-tab" data-toggle="tab" href="#cobros-realizados" role="tab" aria-controls="cobros-realizados" aria-selected="false">
						    		Cobros Realizados 
						    		<span id="badge-cobros-realizados" class="badge badge-light">
			                            0
			                        </span>
						    	</a>
						  	</li>

						  	<li class="nav-item" v-show="modal=='show' || modal=='edit'">
						    	<a class="nav-link" id="logs-tab" data-toggle="tab" href="#logs" role="tab" aria-controls="logs" aria-selected="false">
						    		Historial 
						    		<span id="badge-polizas-log" class="badge badge-light">
			                            0
			                        </span>
						    	</a>
						  	</li>
						</ul>
						<div class="tab-content px-3 py-2" id="myTabPolizasOportunidadesContent">
							<div class="tab-pane fade show active" id="detalles" role="tabpanel" aria-labelledby="detalles-tab">
								<preloader v-if="loadingDetalle"></preloader>
								<div class="row">
					    			<div class="col-md-9">
					    				<div class="form-row">
							    			<div class="col-md-4 mb-3">
							    				<label>Aseguradora:</label>
							    				<catalogo-aseguradoras 
							    					:disabled="form.aseguradora.disabled"
							    					v-model="form.aseguradora.value">
							    				</catalogo-aseguradoras>
									            <div v-if="errors && errors.aseguradora" 
									            	class="text-danger">
							                        {{ errors.aseguradora[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-4 mb-3">
							    				<label>Vendedor:</label>
							    				<catalogo-vendedores 
							    					:disabled="form.vendedor.disabled"
							    					v-model="form.vendedor.value">
							    				</catalogo-vendedores>
									            <div v-if="errors && errors.vendedor" 
									            	class="text-danger">
							                        {{ errors.vendedor[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-4 mb-3">
							    				<label>Cliente:</label>
							    				<catalogo-clientes 
							    					:disabled="form.cliente.disabled"
							    					v-model="form.cliente.value">
							    				</catalogo-clientes>
									            <div v-if="errors && errors.cliente" 
									            	class="text-danger">
							                        {{ errors.cliente[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-6 mb-3">
							    				<label>Producto:</label>
							    				<catalogo-productos 
							    					:disabled="form.producto.disabled"
							    					v-model="form.producto.value">
							    				</catalogo-productos>
									            <div v-if="errors && errors.producto" 
									            	class="text-danger">
							                        {{ errors.producto[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-6 mb-3">
							    				<label>Tipo de Póliza:</label>
							    				<catalogo-tipos-polizas 
							    					:disabled="form.tipoPoliza.disabled"
							    					v-model="form.tipoPoliza.value">
							    				</catalogo-tipos-polizas>
							    				<div v-if="errors && errors.tipo_poliza" 
									            	class="text-danger">
							                        {{ errors.tipo_poliza[0] }}
							                    </div>
							    			</div>

											<div class="col-md-3 mb-3">
							    				<label for="vigencia_ini">
							    					Fecha Vigencia Ini:
							    				</label>
							    				<date-picker 
							    					id="vigencia_ini"
							    					:disabled="form.vigenciaIni.disabled"
							    					class="form-control-sm"
							    					v-model="form.vigenciaIni.value"></date-picker>
									            <div v-if="errors && errors.vigencia_ini" 
									            	class="text-danger">
							                        {{ errors.vigencia_ini[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-3 mb-3">
							    				<label for="vigencia_fin">
							    					Fecha Vigencia Fin:
							    				</label>
							    				<date-picker 
							    					id="vigencia_fin"
							    					:disabled="form.vigenciaFin.disabled"
							    					class="form-control-sm"
							    					v-model="form.vigenciaFin.value"></date-picker>
									            <div v-if="errors && errors.vigencia_fin" 
									            	class="text-danger">
							                        {{ errors.vigencia_fin[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-6 mb-3">
							    				<label>Canal de Pago:</label>
							    				<catalogo-formas-pagos 
							    					:disabled="form.formaPago.disabled"
							    					v-model="form.formaPago.value">
							    				</catalogo-formas-pagos>
									            <div v-if="errors && errors.forma_pago" class="text-danger">
							                        {{ errors.forma_pago[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-4 mb-3">
							    				<label for="referencia">
							    					Póliza Referencia:
							    				</label>
							    				<input
							    					id="referencia"
							    					:disabled="form.referencia.disabled"
							    					v-model="form.referencia.value"
							    					class="form-control form-control-sm"
							    					maxlength="30">
									            <div v-if="errors && errors.referencia" 
									            	class="text-danger">
							                        {{ errors.referencia[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-4 mb-3" v-if="modal!='create'">
							    				<label>
							    					Estado:
							    				</label>
							    				<select2 
							    					v-model="form.estatus.value" 
							    					:disabled="form.estatus.disabled">
							    					<option value="V">Vigente</option>
							    					<option value="N">No Vigente</option>
							    				</select2>
									            <div v-if="errors && errors.estatus" 
									            	class="text-danger">
							                        {{ errors.estatus[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-12 mb-2">
							    				<label for="observaciones">
							    					Observaciones:
							    				</label>
							    				<textarea 
							    					id="observaciones"
							    					:disabled="form.observaciones.disabled"
							    					v-model="form.observaciones.value"
							    					class="form-control"
							    					maxlength="250">
							    				</textarea>
									            <div v-if="errors && errors.observaciones" 
									            	class="text-danger">
							                        {{ errors.observaciones[0] }}
							                    </div>
							    			</div>
							    		</div>
					    			</div>
					    			<div class="col-md-3">
					    				<div class="form-row">
					    					<div class="col-md-12 mb-3">
					    						<label for="sumaAsegurada">Suma Asegurada:</label>
					    						<decimal
					    							id="sumaAsegurada"
					    							:disabled="form.sumaAsegurada.disabled"
					    							v-model="form.sumaAsegurada.value"
					    							class="form-control-sm"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.suma_asegurada" 
									            	class="text-danger">
							                        {{ errors.suma_asegurada[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-6 mb-3">
					    						<label for="deducible1">Deducible 1:</label>
					    						<decimal
					    							id="deducible1"
					    							:disabled="form.deducible1.disabled"
					    							v-model="form.deducible1.value"
					    							class="form-control-sm"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.deducible1" 
									            	class="text-danger">
							                        {{ errors.deducible1[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-6 mb-3">
					    						<label for="deducible2">Deducible 2:</label>
					    						<decimal
					    							id="deducible2"
					    							:disabled="form.deducible2.disabled"
					    							v-model="form.deducible2.value"
					    							class="form-control-sm"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.deducible2" 
									            	class="text-danger">
							                        {{ errors.deducible2[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-12 mb-2">
					    						<label for="premaNeta">Prima Neta:</label>
					    						<decimal
					    							id="premaNeta"
					    							:disabled="form.primaNeta.disabled"
					    							v-model="form.primaNeta.value"
					    							class="form-control-sm"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.prima_neta" 
									            	class="text-danger">
							                        {{ errors.prima_neta[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-12 mb-2">
					    						<label for="primaTotal">Prima Total:</label>
					    						<decimal
					    							id="primaTotal"
					    							:disabled="form.primaTotal.disabled"
					    							v-model="form.primaTotal.value"
					    							class="form-control-sm"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.prima_total" 
									            	class="text-danger">
							                        {{ errors.prima_total[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-6 mb-2">
				    							<label>Saldo:</label>
				    							<copy class="btn bg-secondary text-left text-white btn-block box-shadow" :text="money(form.saldo)">
				    								{{money(form.saldo, true)}}
						    					</copy>
					    					</div>

					    					<div class="col-md-6 mb-2">
				    							<label>Total Cobrado:</label>
				    							<copy class="btn bg-dark text-left text-white btn-block box-shadow" :text="money(totalCobrado)">
						    						{{money(totalCobrado, true)}}
						    					</copy>	
					    					</div>
					    				</div>
					    			</div>
					    		</div>
							</div>

							<div class="tab-pane fade" id="bienes" role="tabpanel" aria-labelledby="bienes-tab">
								<div v-if="modal!='create'">
				    				<bien-asegurado :poliza="form.id.value"></bien-asegurado>
				    			</div>
				    			<div v-else>
									<div class="py-3">
										<button class="btn btn-secondary btn-sm" type="button" v-on:click.prevent="addBien">
										<i class="material-icons">add_circle</i>
										Agregar
										</button>
										<table class="table table-sm table-hover table-borderless" v-if="bienes.length>0">
											<thead>
												<tr>
													<th class="text-left">Bien Asegurado</th>
													<th width="120px" class="text-center">Suma Asegurada</th>
													<th width="120px" class="text-center">Deducible 1</th>
													<th width="120px" class="text-center">Deducible 2</th>
													<th width="120px" class="text-center">Prima Neta</th>
													<th width="120px" class="text-center">Prima Total</th>
													<th class="text-center">Observaciones</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in bienes" :class="{'table-danger':errors && errors['bien_asegurado.'+index]}">
													<td>
														<input type="text" :name="'bien_asegurado['+index+'][DESCRIPCION_BIEN]'" class="form-control form-control-sm" v-model="item.DESCRIPCION_BIEN">
														<div v-if="errors && errors['bien_asegurado.'+index+'.DESCRIPCION_BIEN']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.DESCRIPCION_BIEN'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" :name="'bien_asegurado['+index+'][SUMA_ASEGURADA]'" class="form-control form-control-sm" v-model="item.SUMA_ASEGURADA" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.SUMA_ASEGURADA']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.SUMA_ASEGURADA'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" :name="'bien_asegurado['+index+'][DEDUCIBLE1]'" class="form-control form-control-sm" v-model="item.DEDUCIBLE1" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.DEDUCIBLE1']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.DEDUCIBLE1'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" :name="'bien_asegurado['+index+'][DEDUCIBLE2]'" class="form-control form-control-sm" v-model="item.DEDUCIBLE2" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.DEDUCIBLE2']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.DEDUCIBLE2'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" :name="'bien_asegurado['+index+'][PRIMA_NETA]'" class="form-control form-control-sm" v-model="item.PRIMA_NETA" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.PRIMA_NETA']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.PRIMA_NETA'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" :name="'bien_asegurado['+index+'][PRIMA_TOTAL]'" class="form-control form-control-sm" v-model="item.PRIMA_TOTAL" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.PRIMA_TOTAL']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.PRIMA_TOTAL'][0]}}
														</div>
													</td>
													<td>
														<textarea :name="'bien_asegurado['+index+'][OBSERVACIONES]'" class="form-control form-control-sm" v-model="item.OBSERVACIONES" maxlength="250"></textarea>
														<div v-if="errors && errors['bien_asegurado.'+index+'.OBSERVACIONES']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.OBSERVACIONES'][0]}}
														</div>
													</td>
													<td width="50px">
														<div class="table-hover-options">
															<button type="button" v-on:click="deleteBien(index)" class="btn btn-sm btn-link text-muted" 
															v-if="roleUser() != 'V'">
															<i class="material-icons">delete</i>
															</button>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
										<div v-else class="text-center text-muted py-3">
											No se ha agregado ningún Bien Asegurado.
										</div>
									</div>
				    			</div>
							</div>

						  	<div class="tab-pane fade" id="endosos" role="tabpanel" aria-labelledby="endosos-tab" v-show="modal=='show' || modal=='edit'">
						  		<polizas-endosos :poliza="form.id.value"></polizas-endosos>
						  	</div>
							<div class="tab-pane fade" id="logs" role="tabpanel" aria-labelledby="logs-tab" v-show="modal=='show' || modal=='edit'">
								<polizas-logs :poliza="form.id.value"></polizas-logs>
							</div>

							<div class="tab-pane fade" id="cobros-programados" role="tabpanel" aria-labelledby="cobros-programados-tab" v-show="modal=='show' || modal=='edit'">
								<polizas-cobros-programados :poliza="form.id.value"></polizas-cobros-programados>
							</div>

							<div class="tab-pane fade" id="cobros-realizados" role="tabpanel" aria-labelledby="cobros-realizados-tab" v-show="modal=='show' || modal=='edit'">
								<polizas-cobros-realizados :poliza="form.id.value"></polizas-cobros-realizados>
							</div>
						</div>
			    	</div>
			    	<div class="modal-footer">
			    		<button 
			    			type="button" 
			    			class="btn btn-secondary" 
			    			v-on:click.prevent="validateAndCloseModalPoliza"
			    			:disabled="loadingCreate">
			    			Cancelar
			    		</button>
			        	<button 
			        		type="button"
			        		v-if="modal=='create'"
			        		class="btn btn-success" 
			        		v-on:click.prevent="storePolizas"
			        		:disabled="loadingCreate">
			        		Agregar
			        	</button>

			        	<button 
			        		type="button"
			        		v-if="modal=='edit'"
			        		class="btn btn-success" 
			        		v-on:click.prevent="updatePolizas"
			        		:disabled="loadingCreate">
			        		Actualizar
			        	</button>

			        	<button 
			        		type="button"
			        		v-if="modal=='show'"
			        		class="btn btn-warning" 
			        		v-on:click.prevent="editPolizaButton">
			        		Editar
			        	</button>
			    	</div>
			    </div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['data', 'producto'],

		mounted(){
			this.getPolizas();

			var vm = this;
			$.fn.getDetallePoliza = function () {
				vm.updateDetalle();
			};
		},

		data(){
			return {
				polizas: [],
				loading: false,
				loadingCreate: false,
				loadingDetalle: false,
				modal: false,
				form: {
					id: {
						value: '',
						disabled: false,
					},
					estatus: {
						value: '',
						disabled: false,
					},
					aseguradora: {
						value: '',
						disabled: false,
					},
					cliente: {
						value: '',
						disabled: false,
					},
					vendedor: {
						value: '',
						disabled: false,
					},
					producto: {
						value: '',
						disabled: false,
					},
					tipoPoliza: {
						value: 'N',
						disabled: false,
					},
					vigenciaIni: {
						value: '',
						disabled: false,
					},
					vigenciaFin: {
						value: '',
						disabled: false,
					},
					formaPago: {
						value: '',
						disabled: false,
					},
					referencia: {
						value: '',
						disabled: false,
					},
					observaciones: {
						value: '',
						disabled: false,
					},
					sumaAsegurada: {
						value: 0,
						disabled: false,
					},
					deducible1: {
						value: 0,
						disabled: false,
					},
					deducible2: {
						value: 0,
						disabled: false,
					},
					primaNeta: {
						value: 0,
						disabled: false,
					},
					primaTotal: {
						value: 0,
						disabled: false,
					},
					saldo: 0,
					totalCobro: 0,
				},

				bienes: [],
				bien: '',

				errors: {},
			}
		},

		methods: {
			getUrl: function(poliza){
				return crm.route.polizas.recibo.replace(0, poliza)
			},

			addBien: function(){
				this.bienes.push({
					DESCRIPCION_BIEN: '',
					SUMA_ASEGURADA: 0,
					DEDUCIBLE1: 0,
					DEDUCIBLE2: 0,
					PRIMA_NETA: 0,
					PRIMA_TOTAL: 0,
					OBSERVACIONES: ''
				})
			},

			deleteBien: function(index){
				this.bienes.splice(index, 1)
				this.errors = {}
			},

			getPolizas: function(){
				this.loading = true;
				var url = 'api/oportunidades/'+this.oportunidad.CODIGO_OPORTUNIDAD+'/polizas';

				axios.get(url)
				.then(response => {
					this.polizas = response.data;
					$('#badge-polizas').text(response.data.length);
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			updateDetalle: function(){
				this.loadingDetalle = true;
				var url = 'api/oportunidades/polizas/'+this.form.id.value;

				axios.get(url)
				.then(response => {
					this.setData(response.data);
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loadingDetalle = false;
				});
			},

			storePolizas: function(){
				this.errors = {};
				this.loadingCreate = true;
				var url = 'api/oportunidades/'+this.oportunidad.CODIGO_OPORTUNIDAD+'/polizas';

				axios.post(url, {
					aseguradora: this.form.aseguradora.value,
					cliente: this.form.cliente.value,
					vendedor: this.form.vendedor.value,
					producto: this.form.producto.value,
					tipo_poliza: this.form.tipoPoliza.value,
					vigencia_ini: this.form.vigenciaIni.value,
					vigencia_fin: this.form.vigenciaFin.value,
					bien_asegurado: this.bienes,
					forma_pago: this.form.formaPago.value,
					referencia: this.form.referencia.value,
					observaciones: this.form.observaciones.value,
					suma_asegurada: this.form.sumaAsegurada.value,
					deducible1: this.form.deducible1.value,
					deducible2: this.form.deducible2.value,
					prima_neta: this.form.primaNeta.value,
					prima_total: this.form.primaTotal.value,
				})
				.then(response => {
					this.getPolizas();
					this.closeModalPoliza();
					this.bien = ''
					this.$toasted.show('La póliza ha sido agregado.');
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al agregar póliza.');
				}).then(()=>{
					this.loadingCreate = false;
				});
			},

			updatePolizas: function(){
				this.errors = {};
				this.loadingCreate = true;
				var url = 'api/oportunidades/polizas/'+this.form.id.value;

				axios.put(url, {
					aseguradora: this.form.aseguradora.value,
					estatus: this.form.estatus.value,
					cliente: this.form.cliente.value,
					vendedor: this.form.vendedor.value,
					producto: this.form.producto.value,
					tipo_poliza: this.form.tipoPoliza.value,
					vigencia_ini: this.form.vigenciaIni.value,
					vigencia_fin: this.form.vigenciaFin.value,
					forma_pago: this.form.formaPago.value,
					referencia: this.form.referencia.value,
					observaciones: this.form.observaciones.value,
					suma_asegurada: this.form.sumaAsegurada.value,
					deducible1: this.form.deducible1.value,
					deducible2: this.form.deducible2.value,
					prima_neta: this.form.primaNeta.value,
					prima_total: this.form.primaTotal.value,
				})
				.then(response => {
					this.getPolizas();
					this.closeModalPoliza();
					this.$toasted.show('La póliza ha sido actualizada.');
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar póliza.');
				}).then(()=>{
					this.loadingCreate = false;
				});
			},

			setData: function(data){
				this.form.id.value = '';
				this.form.id.value = data.CODIGO_POLIZA;
				this.form.aseguradora.value = data.CODIGO_ASEGURADORA;
				this.form.estatus.value = data.ESTATUS;
				this.form.cliente.value = data.CODIGO_CLIENTE;
				this.form.vendedor.value = data.CODIGO_VENDEDOR;
				this.form.producto.value = data.CODIGO_PRODUCTO;
				this.form.tipoPoliza.value = data.TIPO_POLIZA;
				this.form.vigenciaIni.value = data.FECHA_VIGENCIA_INI;
				this.form.vigenciaFin.value = data.FECHA_VIGENCIA_FIN;
				this.form.formaPago.value = data.CODIGO_FORMA_PAGO;
				this.form.referencia.value = data.CODIGO_POLIZA_REF;
				this.form.observaciones.value = data.OBSERVACIONES;
				this.form.sumaAsegurada.value = data.SUMA_ASEGURADA;
				this.form.deducible1.value = data.DEDUCIBLE1;
				this.form.deducible2.value = data.DEDUCIBLE2;
				this.form.primaNeta.value = data.PRIMA_NETA;
				this.form.primaTotal.value = data.PRIMA_TOTAL;
				//this.form.saldo = data.TOTAL_COBRADO;
				//this.form.totalCobro = data.cobros_programados ? data.cobros_programados.TOTAL : 0;
				this.form.totalCobro = 0;
				this.form.saldo = 0;

				if (data.endosos) {
					var total = [];
					var saldo = [];

					Object.entries(data.endosos).forEach(([key, val]) => {
						if (val.cobros_programados != null) {
							total.push(val.cobros_programados.TOTAL || []);
						}
					});

					Object.entries(data.endosos).forEach(([key, val]) => {
						if (val.cobros_programados != null) {
							saldo.push(val.cobros_programados.SALDO || []);
						}
					});

					this.form.totalCobro = total.reduce(function(total, num){
						return (parseFloat(total) || 0) + (parseFloat(num) || 0);
					}, 0);

					this.form.saldo = saldo.reduce(function(total, num){
						return (parseFloat(total) || 0) + (parseFloat(num) || 0);
					}, 0);
				}
			},

			editPoliza: function(data){
				this.setData(data);
				this.modal = 'edit';
				this.showModalPoliza();
			},

			editPolizaButton: function(){
				this.modal = 'edit';
				this.showModalPoliza();
			},

			showPoliza: function(data){
				this.setData(data);
				this.modal = 'show';
				this.showModalPoliza();
			},

			openModalPoliza: function(){
				var url = 'api/oportunidades/'+this.oportunidad.CODIGO_OPORTUNIDAD+'/detalles/first';
				axios.get(url)
				.then(response => {
					this.form.producto.value = response.data.CODIGO_PRODUCTO ? response.data.CODIGO_PRODUCTO : '';
				}).catch(error => {
					console.log(error.response);
				});

				this.showModalPoliza();
				this.modal = 'create';
			},

			closeModalPoliza: function(){
				$('#modalPoliza').modal('hide');
				this.cleanFields();
			},

			showModalPoliza: function(){
				$('#modalPoliza').modal('show');
				$('#myTabPolizasOportunidades li:first-child a').tab('show');
			},

			validateAndCloseModalPoliza: function(){
				var $module = this;

				if (this.validaFields()) {
					$.confirm({
				        title: '¿Estás seguro?',
				        content: '¿Deseas descartar los cambios no guardados?',
				        theme: 'supervan', // 'material', 'bootstrap'
				        buttons: {
				            Confirmar: function () {
				            	$module.closeModalPoliza();   
				            },
				            Cancelar: function () {
				            },
				        }
				    });
				}else{
					$module.closeModalPoliza();
				}
			},

			cleanFields: function(){
				this.form.id.value = '';

				this.form.aseguradora.value = this.oportunidad.CODIGO_ASEGURADORA ? this.oportunidad.CODIGO_ASEGURADORA : '';
				this.form.cliente.value = this.oportunidad.CODIGO_CLIENTE ? this.oportunidad.CODIGO_CLIENTE : '';
				this.form.vendedor.value = this.oportunidad.CODIGO_VENDEDOR ? this.oportunidad.CODIGO_VENDEDOR : '';
				this.form.producto.value = this.codigoProducto ? this.codigoProducto : '';
				this.form.estatus.value = '';
				this.form.saldo = 0;
				this.form.tipoPoliza.value = 'N';
				this.form.vigenciaIni.value = moment().format("DD-MM-YYYY") || '';
				this.form.vigenciaFin.value = moment().add(1, 'y').format("DD-MM-YYYY") || '';
				this.form.formaPago.value = '';
				this.form.referencia.value = 0;
				this.form.observaciones.value = '';
				this.form.sumaAsegurada.value = 0;
				this.form.deducible1.value = 0;
				this.form.deducible2.value = 0;
				this.form.primaNeta.value = 0;
				this.form.primaTotal.value = 0;
				this.form.totalCobro = 0;

				this.form.id.disabled = false;
				this.form.aseguradora.disabled = false;
				this.form.estatus.disabled = false;
				this.form.cliente.disabled = false;
				this.form.vendedor.disabled = false;
				this.form.producto.disabled = false;
				this.form.tipoPoliza.disabled = false;
				this.form.vigenciaIni.disabled = false;
				this.form.vigenciaFin.disabled = false;
				this.form.formaPago.disabled = false;
				this.form.referencia.disabled = false;
				this.form.observaciones.disabled = false;
				this.form.sumaAsegurada.disabled = false;
				this.form.deducible1.disabled = false;
				this.form.deducible2.disabled = false;
				this.form.primaNeta.disabled = false;
				this.form.primaTotal.disabled = false;

				this.errors = {};
			},

			validaFields: function(){
				return false;

				if (this.modal != 'show') {
					if(this.form.aseguradora.value != null && this.form.aseguradora.value != ''){
						return true;
					}
					if(this.form.cliente.value != null && this.form.cliente.value != ''){
						return true;
					}
					if(this.form.vendedor.value != null && this.form.vendedor.value != ''){
						return true;
					}
					if(this.form.producto.value != null && this.form.producto.value != ''){
						return true;
					}
					if(this.form.tipoPoliza.value != null && this.form.tipoPoliza.value != ''){
						return true;
					}
					if(this.form.vigenciaIni.value != null && this.form.vigenciaIni.value != ''){
						return true;
					}
					if(this.form.vigenciaFin.value != null && this.form.vigenciaFin.value != ''){
						return true;
					}
					if(this.form.formaPago.value != null && this.form.formaPago.value != ''){
						return true;
					}
					if (this.form.referencia.value != null && this.form.referencia.value > 0) {
						return true;
					}
					if (this.form.observaciones.value != null && this.form.observaciones.value > 0) {
						return true;
					}
					if(this.form.sumaAsegurada.value != null && this.form.sumaAsegurada.value > 0){
						return true;
					}
					if(this.form.deducible1.value != null && this.form.deducible1.value > 0){
						return true;
					}
					if(this.form.deducible2.value != null && this.form.deducible2.value > 0){
						return true;
					}
					if(this.form.primaNeta.value != null && this.form.primaNeta.value > 0){
						return true;
					}
					if(this.form.primaTotal.value != null && this.form.primaTotal.value > 0){
						return true;
					}
				}

				return false;
			},
		},

		computed: {
            oportunidad: function () {
            	return JSON.parse(this.data);
            },

            codigoProducto: function(){
            	return this.producto;
            },

            totalCobrado: function(){
            	return this.form.totalCobro - this.form.saldo;
            }
        },

        watch: {
    		modal: function(value){
    			if (value == 'create') {
    				this.cleanFields();
    			}

    			if (value == 'edit') {
    				this.form.id.disabled = false;
					this.form.aseguradora.disabled = false;
					this.form.estatus.disabled = false;
					this.form.cliente.disabled = false;
					this.form.vendedor.disabled = false;
					this.form.producto.disabled = false;
					this.form.tipoPoliza.disabled = false;
					this.form.vigenciaIni.disabled = false;
					this.form.vigenciaFin.disabled = false;
					this.form.formaPago.disabled = false;
					this.form.referencia.disabled = false;
					this.form.observaciones.disabled = false;
					this.form.sumaAsegurada.disabled = false;
					this.form.deducible1.disabled = false;
					this.form.deducible2.disabled = false;
					this.form.primaNeta.disabled = false;
					this.form.primaTotal.disabled = false;
    			}

    			if(value == 'show'){
    				this.form.id.disabled = true;
					this.form.aseguradora.disabled = true;
					this.form.estatus.disabled = true;
					this.form.cliente.disabled = true;
					this.form.vendedor.disabled = true;
					this.form.producto.disabled = true;
					this.form.tipoPoliza.disabled = true;
					this.form.vigenciaIni.disabled = true;
					this.form.vigenciaFin.disabled = true;
					this.form.formaPago.disabled = true;
					this.form.referencia.disabled = true;
					this.form.observaciones.disabled = true;
					this.form.sumaAsegurada.disabled = true;
					this.form.deducible1.disabled = true;
					this.form.deducible2.disabled = true;
					this.form.primaNeta.disabled = true;
					this.form.primaTotal.disabled = true;
    			}
    		},

    		bienes: {
				handler: function(val, oldVal){
					if (val.length > 0) {
						let suma = [];
						let deducible1 = [];
						let deducible2 = [];
						let neta = [];
						let total = [];

						Object.entries(val).forEach(([key, val]) => {
							suma.push(val.SUMA_ASEGURADA)
							deducible1.push(val.DEDUCIBLE1)
							deducible2.push(val.DEDUCIBLE2)
							neta.push(val.PRIMA_NETA)
							total.push(val.PRIMA_TOTAL)
						});

						var tsuma = suma.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var tdeducible1 = deducible1.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var tdeducible2 = deducible2.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var tneta = neta.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var ttotal = total.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						
						this.form.sumaAsegurada.value = tsuma
						this.form.deducible1.value = tdeducible1
						this.form.deducible2.value = tdeducible2
						this.form.primaNeta.value = tneta
						this.form.primaTotal.value = ttotal
					}

				},
				deep:true
			}
  		}
	}
</script>